module.exports = __webpack_public_path__ + "assets/img/8adee99d108ec2697329aece1c58a31e.png";